export default __webpack_public_path__ + "static/media/food2_thumb.9dbe5676.jpg";